import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../config/environments/environment';
import {MarketService} from './market.service';
import {KeycloakWrapperService} from '../utils/keycloak/keycloak-wrapper.service';

@Injectable({
    providedIn: 'root'
})
export class NewsletterService {

    public isRead: BehaviorSubject<boolean>;

    private readonly httpClient = inject(HttpClient);
    private readonly _kcService = inject(KeycloakWrapperService);
    private readonly _marketService: MarketService = inject(MarketService);

    public loadNewsletterReadStatus(): void {
        this.isNewsletterRead(this._kcService.getKeycloakInstance().profile.email)
            .subscribe((response) => this.isRead = new BehaviorSubject(response));
    }

    public isNewsletterRead(email: string): Observable<boolean> {
        return this.httpClient.get<boolean>(`${environment.apiUrl}/users/${email}/newsletter-read`);
    }

    public setNewsletterRead(email: string): Observable<void> {
        return this.httpClient.patch<void>(`${environment.apiUrl}/users/${email}/newsletter-read`, true);
    }

    public getNewsletterFile(): Observable<HttpResponse<ArrayBuffer>> {
        return this.httpClient.get<ArrayBuffer>(`${environment.apiUrl}/newsletters/${this.marketId}?status=ok`,
            {responseType: 'blob' as 'json', observe: 'response'});
    }

    public get marketId(): number {
        return this._marketService.currentMarket?.id;
    }

}
